// src/views/home/Home.tsx

import React from "react";
import { Spinner } from "react-bootstrap";
import { utils } from "../../core/helpers";
import ProfileCard from "../../feature-module/Instructor/common/profileCard";

import LevelsGrid from "../partials/levelsGrid";
import CategoriesGrid from "../partials/categoriesGrid";

import { useHomeLogic } from "./hooks/useHomeLogic";

import ProgressSummary from "./components/ProgressSummary";
import RecentActivityTable from "./components/RecentActivityTable";

const Home: React.FC = () => {
    const {
        user,
        errors,
        isLoading,
        levelData,
        categoryData,
        groupedContents,
        selectedStatus,
        latestContents,
        isLevelRestricted,
        filteredGroupedContents,
        selectedLevel,
        selectedCategory,
        handleSubmit,
        handleLevelSelect,
        handleStatusSelect,
        getContentStatus,
        handleCategorySelect,
    } = useHomeLogic();


    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }


    return (
        <>
            <style>
                {`
                .ant-table-row-expand-icon-cell {
                    width: 40px;
                    padding-left: 10px !important;
                    padding-right: 10px !important;
                }
                .ant-table-row-expand-icon {
                    background: none !important;
                    border: none !important;
                }
                .ant-table-wrapper {
                    overflow-x: auto;
                }
                `}
            </style>

            {user && (!utils.isUserStudent(user)) && (
                <div className="content pb-0">
                    <div className="container">
                        <ProfileCard />
                    </div>
                </div>
            )}

            <div className="container">
                <form onSubmit={handleSubmit}>
                    {isLevelRestricted ? null : (
                        <>
                            <div className="section-header text-center topcategory-sec">
                                <h2>Level</h2>
                                <p>
                                    Please select an English proficiency level to personalize your
                                    learning experience.
                                </p>
                            </div>
                            <br />
                            <LevelsGrid onSelect={handleLevelSelect} data={levelData} />
                            {errors.level && (
                                <div className="text-danger mt-2">{errors.level}</div>
                            )}
                        </>
                    )}

                    <div
                        className="section-header text-center topcategory-sec mt-4"
                        id="category-section"
                    >
                        <h2>Skill</h2>
                        <p>Now, choose a skill you want to develop.</p>
                    </div>
                    <br />
                    <CategoriesGrid onSelect={handleCategorySelect} data={categoryData} />
                    {errors.category && (
                        <div className="text-danger mt-2">{errors.category}</div>
                    )}

                    <div className="more-details text-center my-4" data-aos="fade-down">
                        <button
                            type="submit"
                            className={`btn btn-secondary btn-xl my-4 ${
                                !selectedCategory || (!isLevelRestricted && !selectedLevel) ? "disabled" : ""
                            }`}
                        >
                            Ready to Learn
                            <i className="fa fa-arrow-right ms-2"></i>
                        </button>
                    </div>
                </form>
            </div>

            {latestContents.length > 0 && (
                <>
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <ProgressSummary
                                    groupedContents={groupedContents}
                                    getContentStatus={getContentStatus}
                                />
                                <RecentActivityTable
                                    filteredGroupedContents={filteredGroupedContents}
                                    selectedStatus={selectedStatus}
                                    onStatusSelect={handleStatusSelect}
                                    getContentStatus={getContentStatus}
                                />

                            </div>
                        </div>
                    </div>
                </>
            )}


        </>
    );
};

export default Home;